import axios from "axios";

import config from "./config";

const api = axios.create({
  baseURL: config.Api_Url, // آدرس پایه API شما
  headers: {
    "Content-Type": "application/json",
  },
});

// افزودن اینترسپتور برای مدیریت خطاها
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // خطاهای عمومی را اینجا مدیریت کنید
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;
